import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./layout/MainLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Work from "./pages/Work";
import Social from "./pages/Social";
import ComingSoon from "./pages/ComingSoon";
import OurTeam from "./pages/OurTeam";
import Awards from "./pages/Awards";
import Reports from "./pages/Reports";
import NewsCoverage from "./pages/NewsCoverage";
import PhotoGallery from "./pages/PhotoGallery";
import Article from "./pages/Article";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* 👈 Always scroll to top on navigation */}
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work" element={<Work />} />
          <Route path="/news-coverage" element={<NewsCoverage />} />
          <Route path="/social" element={<Social />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/photo-gallery" element={<PhotoGallery />} />
          <Route path="/articles" element={<Article />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
